var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',_vm._g({attrs:{"title":_vm.title,"white":""}},_vm.$listeners),[_c('div',{staticClass:"lsva-changelog-modal",domProps:{"innerHTML":_vm._s(_vm.changes)}})])}
var staticRenderFns = []

export { render, staticRenderFns }